<script lang="ts">
	// @ts-nocheck
	import { _ } from 'svelte-i18n';
	import { browser } from '$app/environment';
	import axios from 'axios';
	import moment from 'moment';
	import Header from '../components/Header.svelte';
	import Footer from '../components/Footer.svelte';
	import { onMount, createEventDispatcher } from 'svelte';

	const api_url = 'https://opsroom.sipongidata.my.id';

	let showOtherProfileInput = false;
	let otherProfile = '';

	const handleSubmit = async () => {
		const nama = document.getElementById('nama').value;
		const usia = document.getElementById('usia').value;
		const alamat = document.getElementById('alamat').value;
		const gender = document.querySelector('input[name="gender"]:checked').value;
		const profil = document.querySelector('input[name="profil"]:checked').value;
		const pekerjaan_lain = profil === 'Lainnya' ? otherProfile : '';
		const pendidikan = document.querySelector('input[name="pendidikan"]:checked').value;
		const kemudahan_akses = document.querySelector('input[name="kemudahan_akses"]:checked').value;
		const tampilan_peta = document.querySelector('input[name="tampilan_peta"]:checked').value;
		const info_peta = document.querySelector('input[name="info_peta"]:checked').value;
		const informasi = document.querySelector('input[name="informasi"]:checked').value;
		const penilaian = document.querySelector('input[name="penilaian"]:checked').value;
		const tingkat_kepuasan = document.querySelector('input[name="tingkat_kepuasan"]:checked').value;
		const kritik_saran = document.getElementById('kritik_saran').value;

		const data = {
			nama,
			usia,
			alamat,
			gender,
			profil,
			pekerjaan_lain,
			pendidikan,
			kemudahan_akses,
			tampilan_peta,
			info_peta,
			informasi,
			penilaian,
			tingkat_kepuasan,
			kritik_saran
		};

		try {
			const response = await axios.post(`${api_url}/api/data/survey_kepuasan`, data);
			alert($_('modal_survey.alert'));
			window.location.reload();
		} catch (error) {
			alert($_('modal_survey.alert2'));
		}
	};

	const handleProfileChange = (event) => {
		showOtherProfileInput = event.target.value === 'Lainnya';
	};
</script>

<!-- Navigation-->
<Header />

<!-- Masthead-->
<div class="container-fluid container-banner">
	<div class="container" style="padding-top: 95px;color:white;">
		<h2 class="mb-1" style="font-size: 2rem;text-transform: capitalize;">
			{$_('modal_survey.title')}
		</h2>
	</div>
</div>
<section style="background-color: #f6f4ef;padding-top:20px;">
	<div
		class="container d-flex justify-content-center align-items-center"
		style="min-height: 100vh;"
	>
		<form on:submit|preventDefault={handleSubmit} class="form-content">
			<div class="form-group mb-3">
				<label for="nama" style="font-weight: bold;">{$_('modal_survey.Survey_1')} :</label>
				<input
					type="text"
					class="form-control w-50"
					id="nama"
					placeholder={$_('modal_survey.Survey_1_1')}
				/>
			</div>
			<div class="form-group mb-3">
				<label for="usia" style="font-weight: bold;">{$_('modal_survey.Survey_2')} :</label>
				<input
					type="text"
					class="form-control w-50"
					id="usia"
					placeholder={$_('modal_survey.Survey_2_2')}
				/>
			</div>
			<div class="form-group mb-3">
				<label for="alamat" style="font-weight: bold;">{$_('modal_survey.Survey_3')} :</label>
				<textarea
					class="form-control w-50"
					id="alamat"
					placeholder={$_('modal_survey.Survey_3_3')}
				/>
			</div>
			<!-- Jenis Kelamin -->
			<div class="form-group mb-3">
				<label for="gender" class="col-form-label" style="font-weight: bold;"
					>{$_('modal_survey.Survey_8')} :</label
				>
				<div class="custom-control custom-radio custom-control-inline">
					<input
						type="radio"
						id="gender1"
						name="gender"
						class="form-check-input"
						value="Laki-Laki"
					/>
					<label class="custom-control-label" for="gender1">{$_('modal_survey.Survey_8_1')}</label>
				</div>
				<div class="custom-control custom-radio custom-control-inline">
					<input
						type="radio"
						id="gender2"
						name="gender"
						class="form-check-input"
						value="Perempuan"
					/>
					<label class="custom-control-label" for="gender2">{$_('modal_survey.Survey_8_2')}</label>
				</div>
			</div>
			<!-- Pendidikan -->
			<div class="form-group mb-3">
				<label for="pendidikan" class="col-form-label" style="font-weight: bold;"
					>{$_('modal_survey.Survey_5')} :</label
				>
				<div class="row">
					<div class="col-md-3">
						<div class="form-check">
							<input
								class="form-check-input"
								type="radio"
								name="pendidikan"
								id="pendidikan1"
								value="SD"
							/>
							<label class="form-check-label" for="pendidikan1"
								>{$_('modal_survey.Survey_5_1')}</label
							>
						</div>
						<div class="form-check">
							<input
								class="form-check-input"
								type="radio"
								name="pendidikan"
								id="pendidikan2"
								value="SMP"
							/>
							<label class="form-check-label" for="pendidikan2"
								>{$_('modal_survey.Survey_5_2')}</label
							>
						</div>
						<div class="form-check">
							<input
								class="form-check-input"
								type="radio"
								name="pendidikan"
								id="pendidikan3"
								value="SMA"
							/>
							<label class="form-check-label" for="pendidikan3"
								>{$_('modal_survey.Survey_5_3')}</label
							>
						</div>
					</div>
					<div class="col-md-3">
						<div class="form-check">
							<input
								class="form-check-input"
								type="radio"
								name="pendidikan"
								id="pendidikan4"
								value="S1"
							/>
							<label class="form-check-label" for="pendidikan4"
								>{$_('modal_survey.Survey_5_4')}</label
							>
						</div>
						<div class="form-check">
							<input
								class="form-check-input"
								type="radio"
								name="pendidikan"
								id="pendidikan5"
								value="S2"
							/>
							<label class="form-check-label" for="pendidikan5"
								>{$_('modal_survey.Survey_5_5')}</label
							>
						</div>
						<div class="form-check">
							<input
								class="form-check-input"
								type="radio"
								name="pendidikan"
								id="pendidikan6"
								value="S3"
							/>
							<label class="form-check-label" for="pendidikan6"
								>{$_('modal_survey.Survey_5_6')}</label
							>
						</div>
					</div>
				</div>
			</div>
			<!-- Profesi -->
			<div class="form-group mb-3">
				<label for="profil" class="col-form-label" style="font-weight: bold;"
					>{$_('modal_survey.Survey_4')} :</label
				>
				<div class="row">
					<div class="col-md-3">
						<div class="form-check">
							<input
								class="form-check-input"
								type="radio"
								name="profil"
								id="profil1"
								value="PNS"
								on:change={handleProfileChange}
							/>
							<label class="form-check-label" for="profil1">{$_('modal_survey.Survey_4_1')}</label>
						</div>
						<div class="form-check">
							<input
								class="form-check-input"
								type="radio"
								name="profil"
								id="profil2"
								value="TNI"
								on:change={handleProfileChange}
							/>
							<label class="form-check-label" for="profil2">{$_('modal_survey.Survey_4_2')}</label>
						</div>
						<div class="form-check">
							<input
								class="form-check-input"
								type="radio"
								name="profil"
								id="profil3"
								value="POLRI"
								on:change={handleProfileChange}
							/>
							<label class="form-check-label" for="profil3">{$_('modal_survey.Survey_4_3')}</label>
						</div>
					</div>
					<div class="col-md-3">
						<div class="form-check">
							<input
								class="form-check-input"
								type="radio"
								name="profil"
								id="profil4"
								value="SWASTA"
								on:change={handleProfileChange}
							/>
							<label class="form-check-label" for="profil4">{$_('modal_survey.Survey_4_4')}</label>
						</div>
						<div class="form-check">
							<input
								class="form-check-input"
								type="radio"
								name="profil"
								id="profil5"
								value="WIRAUSAHA"
								on:change={handleProfileChange}
							/>
							<label class="form-check-label" for="profil5">{$_('modal_survey.Survey_4_5')}</label>
						</div>
						<div class="form-check">
							<input
								class="form-check-input"
								type="radio"
								name="profil"
								id="profil6"
								value="Lainnya"
								on:change={handleProfileChange}
							/>
							<label class="form-check-label" for="profil6">{$_('modal_survey.Survey_4_6')}</label>
						</div>
					</div>
				</div>
				{#if showOtherProfileInput}
					<div class="form-group mt-2">
						<input
							type="text"
							class="form-control w-50"
							id="otherProfile"
							bind:value={otherProfile}
							placeholder={$_('modal_survey.Survey_4_7')}
						/>
					</div>
				{/if}
			</div>
			<!-- Kemudahan Akses -->
			<div class="form-group mb-3">
				<label for="kemudahan_akses" class="col-form-label" style="font-weight: bold;"
					>{$_('modal_survey.Survey_6')}</label
				>
				<div class="form-check">
					<input
						class="form-check-input"
						type="radio"
						name="kemudahan_akses"
						id="kemudahan_akses1"
						value="Sangat Mudah"
					/>
					<label class="form-check-label" for="kemudahan_akses1"
						>{$_('modal_survey.Survey_6_1')}</label
					>
				</div>
				<div class="form-check">
					<input
						class="form-check-input"
						type="radio"
						name="kemudahan_akses"
						id="kemudahan_akses3"
						value="Mudah"
					/>
					<label class="form-check-label" for="kemudahan_akses3"
						>{$_('modal_survey.Survey_6_3')}</label
					>
				</div>
				<div class="form-check">
					<input
						class="form-check-input"
						type="radio"
						name="kemudahan_akses"
						id="kemudahan_akses2"
						value="Cukup Mudah"
					/>
					<label class="form-check-label" for="kemudahan_akses2"
						>{$_('modal_survey.Survey_6_2')}</label
					>
				</div>
				<div class="form-check">
					<input
						class="form-check-input"
						type="radio"
						name="kemudahan_akses"
						id="kemudahan_akses4"
						value="Tidak Mudah"
					/>
					<label class="form-check-label" for="kemudahan_akses4"
						>{$_('modal_survey.Survey_6_4')}</label
					>
				</div>
			</div>
			<!-- Tampilan Peta -->
			<div class="form-group mb-3">
				<label for="tampilan_peta" class="col-form-label" style="font-weight: bold;"
					>{$_('modal_survey.Survey_7')}</label
				>
				<div class="form-check">
					<input
						class="form-check-input"
						type="radio"
						name="tampilan_peta"
						id="tampilan_peta1"
						value="Sangat Baik"
					/>
					<label class="form-check-label" for="tampilan_peta1"
						>{$_('modal_survey.Survey_7_1')}</label
					>
				</div>
				<div class="form-check">
					<input
						class="form-check-input"
						type="radio"
						name="tampilan_peta"
						id="tampilan_peta3"
						value="Baik"
					/>
					<label class="form-check-label" for="tampilan_peta3"
						>{$_('modal_survey.Survey_7_3')}</label
					>
				</div>
				<div class="form-check">
					<input
						class="form-check-input"
						type="radio"
						name="tampilan_peta"
						id="tampilan_peta2"
						value="Cukup Baik"
					/>
					<label class="form-check-label" for="tampilan_peta2"
						>{$_('modal_survey.Survey_7_2')}</label
					>
				</div>
				<div class="form-check">
					<input
						class="form-check-input"
						type="radio"
						name="tampilan_peta"
						id="tampilan_peta4"
						value="Tidak Baik"
					/>
					<label class="form-check-label" for="tampilan_peta4"
						>{$_('modal_survey.Survey_7_4')}</label
					>
				</div>
			</div>
			<!-- Info Peta -->
			<div class="form-group mb-3">
				<label for="info_peta" class="col-form-label" style="font-weight: bold;"
					>{$_('modal_survey.Survey_9')}</label
				>
				<div class="form-check">
					<input
						class="form-check-input"
						type="radio"
						name="info_peta"
						id="info_peta1"
						value="Sangat Akurat"
					/>
					<label class="form-check-label" for="info_peta1">{$_('modal_survey.Survey_9_1')}</label>
				</div>
				<div class="form-check">
					<input
						class="form-check-input"
						type="radio"
						name="info_peta"
						id="info_peta3"
						value="Akurat"
					/>
					<label class="form-check-label" for="info_peta3">{$_('modal_survey.Survey_9_3')}</label>
				</div>
				<div class="form-check">
					<input
						class="form-check-input"
						type="radio"
						name="info_peta"
						id="info_peta2"
						value="Cukup Akurat"
					/>
					<label class="form-check-label" for="info_peta2">{$_('modal_survey.Survey_9_2')}</label>
				</div>
				<div class="form-check">
					<input
						class="form-check-input"
						type="radio"
						name="info_peta"
						id="info_peta4"
						value="Tidak Akurat"
					/>
					<label class="form-check-label" for="info_peta4">{$_('modal_survey.Survey_9_4')}</label>
				</div>
			</div>
			<!-- Informasi -->
			<div class="form-group mb-3">
				<label for="informasi" class="col-form-label" style="font-weight: bold;"
					>{$_('modal_survey.Survey_10')}</label
				>
				<div class="form-check">
					<input
						class="form-check-input"
						type="radio"
						name="informasi"
						id="informasi1"
						value="Sangat Mudah"
					/>
					<label class="form-check-label" for="informasi1">{$_('modal_survey.Survey_10_1')}</label>
				</div>
				<div class="form-check">
					<input
						class="form-check-input"
						type="radio"
						name="informasi"
						id="informasi3"
						value="Mudah"
					/>
					<label class="form-check-label" for="informasi3">{$_('modal_survey.Survey_10_3')}</label>
				</div>
				<div class="form-check">
					<input
						class="form-check-input"
						type="radio"
						name="informasi"
						id="informasi2"
						value="Cukup Mudah"
					/>
					<label class="form-check-label" for="informasi2">{$_('modal_survey.Survey_10_2')}</label>
				</div>
				<div class="form-check">
					<input
						class="form-check-input"
						type="radio"
						name="informasi"
						id="informasi4"
						value="Tidak Mudah"
					/>
					<label class="form-check-label" for="informasi4">{$_('modal_survey.Survey_10_4')}</label>
				</div>
			</div>
			<!-- Penilaian -->
			<div class="form-group mb-3">
				<label for="penilaian" class="col-form-label" style="font-weight: bold;"
					>{$_('modal_survey.Survey_11')}</label
				>
				<div class="form-check">
					<input
						class="form-check-input"
						type="radio"
						name="penilaian"
						id="penilaian1"
						value="Sangat Baik"
					/>
					<label class="form-check-label" for="penilaian1">{$_('modal_survey.Survey_11_1')}</label>
				</div>
				<div class="form-check">
					<input
						class="form-check-input"
						type="radio"
						name="penilaian"
						id="penilaian3"
						value="Baik"
					/>
					<label class="form-check-label" for="penilaian3">{$_('modal_survey.Survey_11_3')}</label>
				</div>
				<div class="form-check">
					<input
						class="form-check-input"
						type="radio"
						name="penilaian"
						id="penilaian2"
						value="Cukup Baik"
					/>
					<label class="form-check-label" for="penilaian2">{$_('modal_survey.Survey_11_2')}</label>
				</div>
				<div class="form-check">
					<input
						class="form-check-input"
						type="radio"
						name="penilaian"
						id="penilaian4"
						value="Tidak Baik"
					/>
					<label class="form-check-label" for="penilaian4">{$_('modal_survey.Survey_11_4')}</label>
				</div>
			</div>
			<!-- Tingkat Kepuasan -->
			<div class="form-group mb-3">
				<label for="tingkat_kepuasan" class="col-form-label" style="font-weight: bold;"
					>{$_('modal_survey.Survey_12')}</label
				>
				<div class="form-check">
					<input
						class="form-check-input"
						type="radio"
						name="tingkat_kepuasan"
						id="tingkat_kepuasan1"
						value="Sangat Baik"
					/>
					<label class="form-check-label" for="tingkat_kepuasan1"
						>{$_('modal_survey.Survey_12_1')}</label
					>
				</div>
				<div class="form-check">
					<input
						class="form-check-input"
						type="radio"
						name="tingkat_kepuasan"
						id="tingkat_kepuasan3"
						value="Baik"
					/>
					<label class="form-check-label" for="tingkat_kepuasan3"
						>{$_('modal_survey.Survey_12_3')}</label
					>
				</div>
				<div class="form-check">
					<input
						class="form-check-input"
						type="radio"
						name="tingkat_kepuasan"
						id="tingkat_kepuasan2"
						value="Cukup Baik"
					/>
					<label class="form-check-label" for="tingkat_kepuasan2"
						>{$_('modal_survey.Survey_12_2')}</label
					>
				</div>
				<div class="form-check">
					<input
						class="form-check-input"
						type="radio"
						name="tingkat_kepuasan"
						id="tingkat_kepuasan4"
						value="Tidak Baik"
					/>
					<label class="form-check-label" for="tingkat_kepuasan4"
						>{$_('modal_survey.Survey_12_4')}</label
					>
				</div>
				<div class="form-group mb-3">
					<label for="kritik_saran" style="font-weight: bold;">KRITIK & SARAN :</label>
					<textarea
						class="form-control w-50"
						id="kritik_saran"
						placeholder="Masukkan Kritik & Saran Anda"
					/>
				</div>
			</div>
			<button type="submit" class="btn btn-success submit-button"
				>{$_('modal_survey.Survey_13')}</button
			>
		</form>
	</div>
</section>

<!-- Navigation-->
<Footer />

<style>
	.form-group label {
		margin-bottom: 10px;
	}

	.form-group input,
	.form-group textarea,
	.form-check {
		margin-top: 5px;
	}

	.form-content {
		width: 100%;
		max-width: 800px;
		background: white;
		padding: 20px;
		border-radius: 8px;
		box-shadow: 0 4px 10px rgba(0, 0, 0, 0.1);
	}
</style>
